// Copyright (c) Docugami, Inc. All rights reserved.

import { StorageAccessor } from "utils/StorageAccessor";
import { FeatureFlagActionTypes, SET_FEATURE_FLAG, FeatureFlags, getFeatureFlagKey } from "./types";

/**
 * Dispatched to set the given feature flag type to a target value
 * @param payload The feature flag payload
 */
export function setFeatureFlag(flag: FeatureFlags, enabled: boolean): FeatureFlagActionTypes {
    const storageKey = getFeatureFlagKey(flag);
    new StorageAccessor().setBoolean(storageKey, enabled);

    return {
        type: SET_FEATURE_FLAG,
        payload: { featureFlag: flag, value: enabled }
    }
}

/**
 * Gets the cached value for the feature flag from local storage
 * @param flag The feature flag to retrieve
 * @param defaultValue The default value
 */
export function getFeatureFlagFromCache(flag: FeatureFlags, defaultValue: boolean) : boolean {
    const storageKey = getFeatureFlagKey(flag);
    return new StorageAccessor().getBoolean(storageKey, defaultValue);
}
